import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IEnquiry, IEnquiryAndDataRequest, IEnquiryApi, IEnquiryOrganizations } from '@vivli/features/enquiry/infastructure/interface';
import { EnquiryStatusEnum } from '@vivli/features/enquiry/infastructure/enum';

export const useEnquiryApi = (): IEnquiryApi => {
    const { handleGet, handlePost, handlePut } = useAuthRestApi();
    const getEnquiryList = (): Observable<IEnquiry[]> => {
        return handleGet<IEnquiry[]>(`/Enquiry/list`);
    };

    const updateEnquiry = (enquiry: IEnquiry, notify: boolean): Observable<IEnquiry> => {
        const notifyString = notify ? 'true' : 'false';
        return handlePut<IEnquiry>(`/Enquiry/${notifyString}`, enquiry);
    };

    const getStudyInfo = (nctOrSponsorId: string): Observable<any> => {
        return handlePost(`/Enquiry/studyinfo/`, nctOrSponsorId);
    };

    const getEnquiryOrganizations = (): Observable<IEnquiryOrganizations[]> => {
        return handleGet(`/Enquiry/organizations`);
    };

    const getEnquiry = (id: string): Observable<IEnquiry> => {
        return handleGet<IEnquiry>(`/Enquiry/${id}`);
    };

    const updateStatus = (enquiry: IEnquiry, status: EnquiryStatusEnum): Observable<IEnquiry> => {
        return handlePut<IEnquiry>(`/Enquiry/changestatus/${enquiry.id}/${status}`, enquiry);
    };

    const addDirStudy = (enquiryId: number, dirId: number, targetDataRequestTitle: string): Observable<IEnquiryAndDataRequest> => {
        return handlePost<IEnquiryAndDataRequest>(
            `/DataRequests/enquiry/addToDataRequest/${enquiryId}/${dirId}/${encodeURI(targetDataRequestTitle.replace(/\//g, '@@--@@'))}`
        );
    };

    return {
        getEnquiryList,
        updateEnquiry,
        getStudyInfo,
        getEnquiryOrganizations,
        getEnquiry,
        updateStatus,
        addDirStudy
    };
};
